import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    flex-direction: row;\n    padding-top: ", ";\n    border-radius: ", ";\n    box-shadow: ", ";\n    background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var StyledWrapper = styled.div(_templateObject(), function (props) {
  return props.theme.components.dateRange.calendarsPaddingTop;
}, function (props) {
  return props.theme.components.dateRange.calendarsBorderRadius;
}, function (props) {
  return props.theme.components.dateRange.calendarsBoxShadow;
}, function (props) {
  return props.theme.components.dateRange.backgroundColor;
});